import { render } from "./CustomerSelect.vue?vue&type=template&id=4c25e8e3&scoped=true"
import script from "./CustomerSelect.vue?vue&type=script&lang=js"
export * from "./CustomerSelect.vue?vue&type=script&lang=js"

import "./CustomerSelect.vue?vue&type=style&index=0&id=4c25e8e3&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c25e8e3"],['__file',"src/components/h5/partner/CustomerSelect.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4c25e8e3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4c25e8e3', __exports__)) {
    api.reload('4c25e8e3', __exports__)
  }
  
  module.hot.accept("./CustomerSelect.vue?vue&type=template&id=4c25e8e3&scoped=true", () => {
    api.rerender('4c25e8e3', render)
  })

}


export default __exports__